export class AddToCart extends window.BAO.CustomElement({
  SuperClass: HTMLButtonElement,
}) {
  static get requiredAttributes () {
    return ['data-ids', 'data-quantities']
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(this, 'click', this.handleClick.bind(this))
  }

  handleClick () {
    window.BAO.Cart.addItem(this.items)
  }

  /**
   * @returns {string[]}
   */
  get ids () {
    return this.dataset.ids.split(',')
  }

  /**
   * @returns {string[]}
   */
  get quantities () {
    return this.dataset.quantities.split(',')
  }

  /**
   * @returns {PotentialCartItem[]}
   */
  get items () {
    return this.ids.map((id, i) => ({
      id,
      quantity: this.quantities[i],
    }))
  }
}

if (!customElements.get('add-to-cart')) {
  customElements.define('add-to-cart', AddToCart, {
    extends: 'button',
  })
}
